/**
 * Token-Ablage fuer das Backend-JWT in der sessionStorage.
 *
 * Bewusst als eigenes Modul (statt in authService.ts), damit apiClient.ts
 * die Token-Funktionen nutzen kann, ohne einen Import-Zyklus
 * (authService -> apiClient -> authService) zu erzeugen.
 */

/** sessionStorage-Schluessel, unter dem das JWT abgelegt wird. */
export const AUTH_TOKEN_STORAGE_KEY = 'mvgenMgmnt.authToken';

/** Liest das gespeicherte JWT (oder null, wenn keines vorhanden ist). */
export function getToken(): string | null {
  return window.sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

/** Speichert das JWT in der sessionStorage. */
export function setToken(token: string): void {
  window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
}

/** Entfernt das JWT aus der sessionStorage. */
export function clearToken(): void {
  window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
}
